import { ICSSInJSStyle, pxToRem } from "@fluentui/react-northstar";

import { useFluentColorScheme } from "../../../shared/theme/useColorScheme";

interface SidePanelStyles {
  sidePanel: ICSSInJSStyle;
  closeButton: ICSSInJSStyle;
  dropdownContainer: ICSSInJSStyle;
}

export const useSidePanelStyles: () => SidePanelStyles = () => {
  const { main, white } = useFluentColorScheme();
  return {
    sidePanel: {
      backgroundColor: main.background3,
      padding: `${pxToRem(18)} ${pxToRem(24)} ${pxToRem(24)} ${pxToRem(24)}`,
      maxWidth: "320px",
    },
    closeButton: {
      color: white.foreground,
      borderRadius: "4px",
      backgroundColor: "transparent",
    },
    dropdownContainer: {
      height: "272px",
      width: "265px",
    },
  };
};
